export default __webpack_public_path__ + "static/media/V210_RoHS.c5edde1e.pdf";